<template>
    <v-flex>

        <v-card pa-0>
            <div>
                <!-- quill-editor -->
                <quill-editor
                        ref="myTextEditor"
                        v-model="content"
                        :options="editorOption"
                        @change="onTextWritten"
                />

                <!-- to show formatted content -->
                <!--
                <div v-html="content">
                </div>
                -->

                <!-- to show html tags -->
                <!--
                <div class="quill-code">
                    <code
                            class="hljs"
                            v-html="contentCode"
                    ></code>
                </div>
                -->
            </div>
        </v-card>

    </v-flex>
</template>

<script>
    // Quill-editor dependencies
    import hljs from "highlight.js";       // for inline code
    import "quill/dist/quill.core.css";    // style
    import "quill/dist/quill.snow.css";    // style
    import "quill/dist/quill.bubble.css";  // style
    import {quillEditor,} from "vue-quill-editor"; // component

    export default {
        name: "DescriptionCreator",
        components: {quillEditor,},
        props: {
            contentProp: String,
        },
        data() {
            return {
                name: "01-example",
                content: "",
                editorOption: {
                    modules: {
                        toolbar: [
                            ["bold", "italic", "underline", "strike",],
                            /*["blockquote", "code-block",],*/
                            /*[{"header": 1,}, {"header": 2,},],*/
                            [{"list": "ordered",}, {"list": "bullet",},],
                            [{"script": "sub",}, {"script": "super",},],
                            [{"indent": "-1",}, {"indent": "+1",},],
                            /*[{"direction": "rtl",},],*/
                            /*[{"size": ["small", false, "large", "huge",],},],*/
                            /*[{"header": [1, 2, 3, 4, 5, 6, false,],},],*/
                            /*[{"font": [],},],*/
                            [{"color": [],}, {"background": [],},],
                            [{"align": [],},],
                            ["clean",],
                            /*["link", "image", "video",],*/
                            ["link",],
                        ],
                        syntax: {
                            highlight: text => hljs.highlightAuto(text).value,
                        },
                    },
                    placeholder: 'Insert here the description...',
                    theme: 'snow'
                },
            };
        },
        created(){
        },
        computed: {
            contentCode() {
                return this.content.replace(new RegExp("href=\"www\.","g"),"href=\"http://www.")
                //return hljs.highlightAuto(this.content).value;
            },
        },
        watch: {
            contentProp(newVal) {
                this.content = newVal
            }
        },
        methods: {
            onTextWritten(){
                this.$emit('onTextWritten' , this.contentCode)
            }
        },
    };
</script>

<style lang="scss" scoped>

</style>

<style>
    .ql-container {
        font-size: 16px;
    }
</style>